import requests from "./http";

class ImageService {
  getItems() {
    return requests.get(`/images`);
  }
}

export default new ImageService();
